<template>
  <section>
    <h3 class="primary--text"><v-icon color="primary">settings</v-icon> {{ $t('parametro.preferencias') }}</h3>
    <v-tabs v-model="active">
      <v-tabs-bar class="primary tab-preferencias" dark>
        <v-tabs-item
          key="parametros"
          href="#parametros"
          v-if="$store.state.permissions['parametros:read']"
          ripple>
          <v-icon>settings_applications</v-icon> {{ $t('parametro.title') }}
        </v-tabs-item>
        <v-tabs-item
          key="roles"
          href="#roles"
          v-if="$store.state.permissions['roles:read']"
          ripple>
          <v-icon>person_outline</v-icon> {{ $t('rol.title') }}
        </v-tabs-item>
        <v-tabs-slider color="warning"></v-tabs-slider>
      </v-tabs-bar>
      <v-tabs-items>
        <v-tabs-content
          key="parametros"
          id="parametros">
          <v-card flat>
            <parametro v-if="$store.state.permissions['parametros:read'] && active == 'parametros'"></parametro>
          </v-card>
        </v-tabs-content>
        <v-tabs-content
          key="roles"
          id="roles">
          <v-card flat>
            <rol v-if="$store.state.permissions['roles:read'] && active == 'roles'"></rol>
          </v-card>
        </v-tabs-content>
      </v-tabs-items>
    </v-tabs>
  </section>
</template>

<script>
import Rol from './Rol';
import Parametro from './Parametro';

export default {
  data () {
    return {
      active: 'parametros'
    };
  },
  components: {
    Rol,
    Parametro
  },
  watch: {
    active: function (val) {
      console.log(val);
    }
  }
};
</script>

<style lang="scss">
  .tab-preferencias {
    .tabs__wrapper {
      margin: 0 !important;
    }
  }
</style>



// WEBPACK FOOTER //
// Preferencias.vue?20a5f390